import React, { useState, useEffect, useContext } from 'react';
import './LongestResponse.css';
import MonitoredIndividualCarousel from '../MonitoredIndividualCarousel/MonitoredIndividualCarousel';
import formatDuration from '../../common/formatDuration';
import { CardLongestResponseContext } from '../../contexts/CardLongestResponseContext';
import logComponent from '../../common/logComponent';

export default function LongestResponseContent() {
  const cardLongestResponseContext = useContext(CardLongestResponseContext);
  const [contentData, setContentData] = useState(null);
  const [monitoredIndividualsAndUnits, setMonitoredIndividualsAndUnits] = useState(null);
  const [visibleAlarmer, setVisibleAlarmer] = useState(null);
  if (logComponent('LongestResponseContent')) { console.debug('LongestResponseContent rendered'); }


  useEffect(() => {
    if (logComponent('LongestResponseContent')) { console.debug('LongestResponseContent useEffect [cardLongestResponseContext.longestResponse]'); }
    setContentData(cardLongestResponseContext.longestResponse ? [ ...cardLongestResponseContext.longestResponse ] : null);
  }, [cardLongestResponseContext.longestResponse]);


  useEffect(() => {
    if (logComponent('LongestResponseContent')) { console.debug('LongestResponseContent useEffect [cardLongestResponseContext.longestResponseMonitoredIndividualsAndUnits]'); }
    setMonitoredIndividualsAndUnits(cardLongestResponseContext.longestResponseMonitoredIndividualsAndUnits ? [...cardLongestResponseContext.longestResponseMonitoredIndividualsAndUnits ] : null);
  }, [cardLongestResponseContext.longestResponseMonitoredIndividualsAndUnits]);

  const updateVisibleAlarmer = (alarmer) => {
    if (logComponent('LongestResponseContent')) {console.debug('LongestResponseContent updateVisibleAlarmer'); }
    let newVisibleAlarmer;

    if (alarmer.unitId) {
      newVisibleAlarmer = contentData.find(item => item.unit && item.unit.unitId === alarmer.unitId);
    } else if (alarmer.monitoredIndividualId) {
      newVisibleAlarmer = contentData.find(item => item.monitoredIndividual && item.monitoredIndividual.monitoredIndividualId === alarmer.monitoredIndividualId);
    } else {
      return;
    }

    setVisibleAlarmer(newVisibleAlarmer);
  }

  return (contentData &&
    (contentData.length > 0 ?
    <MonitoredIndividualCarousel monitoredIndividuals={monitoredIndividualsAndUnits} onChange={updateVisibleAlarmer}>
        <ul className="Longest-Response__alarm-info-list">
          <li key="longestTotalAlarms" className="Longest-Response__alarm-info-item">
            <p>Total alarms:</p>
            <p>{visibleAlarmer && visibleAlarmer.alarmCount}</p>
          </li>
          <li key="longestResponseTime" className="Longest-Response__alarm-info-item">
            <p>Longest response time:</p>
            <p>{visibleAlarmer && formatDuration(visibleAlarmer.averageResponseTimeSec, 'hh:mm:ss')}</p>
          </li>
        </ul>
      </MonitoredIndividualCarousel> :
      <p className="Longest-Response__empty-message">No alarms reported</p>));

}
